import type { MessageDescriptor} from 'react-intl';
import { useIntl } from 'react-intl'

const useFormatMessage = () => {
  const { formatMessage } = useIntl()

  return (id: MessageDescriptor['id'], values?: Record<string, string | number | boolean | null | undefined | Date>) =>
    formatMessage({ id }, values)
}

export default useFormatMessage
